import { useSelector } from 'react-redux';
import { ReduxState } from '../../types/reduxState';

export const FEATURES = [
  'admin-localization',
  'auth-migration',
  'carousel--progress',
  'conversion-mission',
  'conversion-mission--release-1',
  'duration-fixes', // inbox
  'insurance',
  'mobile-webview',
  'pricing-v2--nav',
  'synced-events',
  'unified-trip-cart--summary',
] as const;

export type Feature = (typeof FEATURES)[number];

// Feature flags that are forced on
export const ENABLED_FEATURES: Feature[] = [
  'conversion-mission',
  'pricing-v2--nav',
];

const getFeatureFlags = (state: ReduxState): Feature[] => state.featureFlags;

function useFeatureFlag(feature: Feature): boolean {
  const featureFlags = useSelector(getFeatureFlags);
  return featureFlags.includes(feature) || ENABLED_FEATURES.includes(feature);
}

export default useFeatureFlag;
